import { render, staticRenderFns } from "./MarketCapMethodology.vue?vue&type=template&id=9edab8d0&"
import script from "./MarketCapMethodology.vue?vue&type=script&lang=js&"
export * from "./MarketCapMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports